enum ProcessRequestState {
	NEW = 'NEW',
	IN_PROCESS = 'IN_PROCESS',
	HANDLING_BEFORE_EXECUTION = 'HANDLING_BEFORE_EXECUTION',
	FINISHED_BEFORE_EXECUTION = 'FINISHED_BEFORE_EXECUTION',
	HANDLING_EXECUTION = 'HANDLING_EXECUTION',
	FINISHED_EXECUTION = 'FINISHED_EXECUTION',
	WAITING_TRIGGERS_EXECUTION = 'WAITING_TRIGGERS_EXECUTION',
	FINISHED = 'FINISHED'
}

export const isStateFinishing = (state: ProcessRequestState): boolean => {
	return state === ProcessRequestState.HANDLING_EXECUTION ||
		state === ProcessRequestState.HANDLING_BEFORE_EXECUTION ||
		state === ProcessRequestState.FINISHED_BEFORE_EXECUTION ||
		state === ProcessRequestState.WAITING_TRIGGERS_EXECUTION ||
		state === ProcessRequestState.FINISHED_EXECUTION;
};

export const isStateFinished = (state: ProcessRequestState): boolean => {
	return state === ProcessRequestState.FINISHED;
};

export const isStateInProcess = (state: ProcessRequestState): boolean => {
	return state === ProcessRequestState.NEW ||
		state === ProcessRequestState.IN_PROCESS;
};

export default ProcessRequestState;